import api from './api';
export const subscribersApi = { async create(subscriber) { const path = '/api/v1/subscribers'; const response = await api({ method: 'post', data: { subscriber }, url: path }); return response.subscriber; } };
